var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import styles from './sds-tabs-content.lit.scss';
import { SidebarUtilities } from '../utilities/sidebar';
import { sdsCustomElement } from '../utilities/custom-components';
import { SidebarResizeHandler } from '../utilities/sidebar-resizing';
/**
 * `sds-tab-content` represents the content section of a tab within the `sds-tabs` component.
 * It supports configuring a sidebar with customizable width and position.
 *
 * ### Attributes
 * - `sidebar`: Defines the type of sidebar to be displayed within the tab content.
 * - `sidebarWidth`: Specifies the width of the sidebar.
 * - `sidebarPosition`: Sets the position of the sidebar within the content (default is "right").
 *
 * @tag sds-tab-content
 */
let SdsTabContent = (() => {
    var _SdsTabContent_sidebarResizable_accessor_storage, _SdsTabContent_sidebar_accessor_storage, _SdsTabContent_sidebarWidth_accessor_storage, _SdsTabContent_sidebarPosition_accessor_storage, _SdsTabContent__tabsSidebarResizeHandler_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-tab-content')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _sidebarResizable_decorators;
    let _sidebarResizable_initializers = [];
    let _sidebarResizable_extraInitializers = [];
    let _sidebar_decorators;
    let _sidebar_initializers = [];
    let _sidebar_extraInitializers = [];
    let _sidebarWidth_decorators;
    let _sidebarWidth_initializers = [];
    let _sidebarWidth_extraInitializers = [];
    let _sidebarPosition_decorators;
    let _sidebarPosition_initializers = [];
    let _sidebarPosition_extraInitializers = [];
    var SdsTabContent = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsTabContent_sidebarResizable_accessor_storage.set(this, __runInitializers(this, _sidebarResizable_initializers, void 0));
            _SdsTabContent_sidebar_accessor_storage.set(this, (__runInitializers(this, _sidebarResizable_extraInitializers), __runInitializers(this, _sidebar_initializers, void 0)));
            _SdsTabContent_sidebarWidth_accessor_storage.set(this, (__runInitializers(this, _sidebar_extraInitializers), __runInitializers(this, _sidebarWidth_initializers, '')));
            _SdsTabContent_sidebarPosition_accessor_storage.set(this, (__runInitializers(this, _sidebarWidth_extraInitializers), __runInitializers(this, _sidebarPosition_initializers, 'right')));
            _SdsTabContent__tabsSidebarResizeHandler_accessor_storage.set(this, (__runInitializers(this, _sidebarPosition_extraInitializers), null));
        }
        /**
         * Indicates whether the component is resizable.
         * When set to true, the component can be resized by the user.
         * @attr
         */
        get sidebarResizable() { return __classPrivateFieldGet(this, _SdsTabContent_sidebarResizable_accessor_storage, "f"); }
        set sidebarResizable(value) { __classPrivateFieldSet(this, _SdsTabContent_sidebarResizable_accessor_storage, value, "f"); }
        /**
         * Defines the type of sidebar to be displayed within the tab content.
         *
         * @attr {string} sidebar - The sidebar type.
         */
        get sidebar() { return __classPrivateFieldGet(this, _SdsTabContent_sidebar_accessor_storage, "f"); }
        set sidebar(value) { __classPrivateFieldSet(this, _SdsTabContent_sidebar_accessor_storage, value, "f"); }
        /**
         * Specifies the width of the sidebar.
         *
         * Defaults to an empty string.
         *
         * @attr {number} sidebarWidth - The width of the sidebar.
         */
        get sidebarWidth() { return __classPrivateFieldGet(this, _SdsTabContent_sidebarWidth_accessor_storage, "f"); }
        set sidebarWidth(value) { __classPrivateFieldSet(this, _SdsTabContent_sidebarWidth_accessor_storage, value, "f"); }
        /**
         * Sets the position of the sidebar within the content.
         *
         * Defaults to `'right'`.
         *
         * @attr {string} sidebarPosition - The position of the sidebar.
         */
        get sidebarPosition() { return __classPrivateFieldGet(this, _SdsTabContent_sidebarPosition_accessor_storage, "f"); }
        set sidebarPosition(value) { __classPrivateFieldSet(this, _SdsTabContent_sidebarPosition_accessor_storage, value, "f"); }
        get _tabsSidebarResizeHandler() { return __classPrivateFieldGet(this, _SdsTabContent__tabsSidebarResizeHandler_accessor_storage, "f"); }
        set _tabsSidebarResizeHandler(value) { __classPrivateFieldSet(this, _SdsTabContent__tabsSidebarResizeHandler_accessor_storage, value, "f"); }
        render() {
            return html `
            <div class="sds-tab-container">
                <div
                    class="sds-tab-content"
                    part="sds-tab-content"
                    style="${SidebarUtilities.getContentMargin(Number(this.sidebarWidth), this.sidebar, this.sidebarPosition)}"
                >
                    <slot @slotchange="${() => this.requestUpdate()}"></slot>
                </div>
                <div
                    class="sds-tab-sidebar ${this.sidebarPosition === 'left'
                ? 'sds-tab-sidebar--left'
                : 'sds-tab-sidebar--right'}"
                    style="${SidebarUtilities.getSidebarStyles(Number(this.sidebarWidth), this.sidebar, this.sidebarPosition)}"
                >
                    ${this.renderResizeBorder()}
                    <slot name="sidebar" @slotchange="${() => this.requestUpdate()}"></slot>
                </div>
            </div>
        `;
        }
        renderResizeBorder() {
            if (this.sidebarResizable) {
                return html ` <div id="resize-border" class="sds-tab-sidebar__resize-border"></div>`;
            }
        }
        async connectedCallback() {
            super.connectedCallback();
            if (this.hasAttribute('sidebar-resizable')) {
                await this.updateComplete;
                this._tabsSidebarResizeHandler = new SidebarResizeHandler(this, () => this.sidebarPosition, () => this.sidebarWidth, width => (this.sidebarWidth = width));
                this._tabsSidebarResizeHandler.initResize();
            }
            this.observeTextDirectionChanges();
        }
        disconnectedCallback() {
            var _a;
            (_a = this._tabsSidebarResizeHandler) === null || _a === void 0 ? void 0 : _a.destroy();
            super.disconnectedCallback();
        }
        observeTextDirectionChanges() {
            const observer = new MutationObserver(() => {
                this.requestUpdate(); // Trigger an update when the text direction changes
            });
            observer.observe(document.documentElement, { attributes: true, attributeFilter: ['dir'] });
        }
    };
    _SdsTabContent_sidebarResizable_accessor_storage = new WeakMap();
    _SdsTabContent_sidebar_accessor_storage = new WeakMap();
    _SdsTabContent_sidebarWidth_accessor_storage = new WeakMap();
    _SdsTabContent_sidebarPosition_accessor_storage = new WeakMap();
    _SdsTabContent__tabsSidebarResizeHandler_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTabContent");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _sidebarResizable_decorators = [property({ type: Boolean, attribute: 'sidebar-resizable' })];
        _sidebar_decorators = [property({ type: String, reflect: true })];
        _sidebarWidth_decorators = [property({ type: Number, attribute: 'sidebar-width' })];
        _sidebarPosition_decorators = [property({ type: String, attribute: 'sidebar-position' })];
        __esDecorate(_classThis, null, _sidebarResizable_decorators, { kind: "accessor", name: "sidebarResizable", static: false, private: false, access: { has: obj => "sidebarResizable" in obj, get: obj => obj.sidebarResizable, set: (obj, value) => { obj.sidebarResizable = value; } }, metadata: _metadata }, _sidebarResizable_initializers, _sidebarResizable_extraInitializers);
        __esDecorate(_classThis, null, _sidebar_decorators, { kind: "accessor", name: "sidebar", static: false, private: false, access: { has: obj => "sidebar" in obj, get: obj => obj.sidebar, set: (obj, value) => { obj.sidebar = value; } }, metadata: _metadata }, _sidebar_initializers, _sidebar_extraInitializers);
        __esDecorate(_classThis, null, _sidebarWidth_decorators, { kind: "accessor", name: "sidebarWidth", static: false, private: false, access: { has: obj => "sidebarWidth" in obj, get: obj => obj.sidebarWidth, set: (obj, value) => { obj.sidebarWidth = value; } }, metadata: _metadata }, _sidebarWidth_initializers, _sidebarWidth_extraInitializers);
        __esDecorate(_classThis, null, _sidebarPosition_decorators, { kind: "accessor", name: "sidebarPosition", static: false, private: false, access: { has: obj => "sidebarPosition" in obj, get: obj => obj.sidebarPosition, set: (obj, value) => { obj.sidebarPosition = value; } }, metadata: _metadata }, _sidebarPosition_initializers, _sidebarPosition_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTabContent = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTabContent = _classThis;
})();
export { SdsTabContent };
